import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Lo compré sin expectativas altas y quedé impactado. El capítulo de detección de manipuladores cambió cómo me relaciono en el trabajo. Ya identifiqué a dos personas con las que necesitaba poner límites. Totalmente recomendado.',
    initial: 'A',
    name: 'Andrés Gutiérrez',
    role: 'Gerente de ventas · Bogotá, Colombia'
  }, {
    quote: 'Soy psicóloga y debo decir que el contenido está bien fundamentado. No es el típico libro de autoayuda superficial — hay rigor detrás. Lo recomendé ya a tres pacientes que trabajan en entornos de alta presión.',
    initial: 'V',
    name: 'Valeria Rondón',
    role: 'Psicóloga clínica · Buenos Aires, Argentina'
  }, {
    quote: 'Emprendedor desde hace 6 años y nadie me enseñó a leer dinámicas de poder. Este libro me abrió los ojos. Las 7 frases del bono las usé en una negociación la semana siguiente — cerré el trato. No más dudas, solo resultados.',
    initial: 'M',
    name: 'Miguel Herrera',
    role: 'Emprendedor digital · Ciudad de México'
  }];
  const screenshots = ['https://i.postimg.cc/P5bnrBvY/download-1-min.png', 'https://i.postimg.cc/nhftxHrn/download-2-min.png', 'https://i.postimg.cc/LsHKqNj7/download-min.png'];
  return <section className="py-14 md:py-20 bg-[linear-gradient(180deg,var(--negro-medio)_0%,#0f0800_100%)]" data-id="element-394">
      <div className="container" data-id="element-395">
        <div className="text-center max-w-[600px] mx-auto mb-4" data-id="element-396">
          <div className="section-label justify-center" data-id="element-397">Testimonios reales</div>
          <div className="flex justify-center gap-1 my-2.5 mb-3.5" data-id="element-398">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-[22px] h-[22px] fill-dorado text-dorado" data-id="element-399" />)}
          </div>
          <h2 className="font-playfair text-[clamp(1.7rem,3.5vw,2.7rem)] font-bold leading-[1.2] text-blanco text-center" data-id="element-400">
            Quienes ya dominan el Código Oscuro
          </h2>
        </div>

        <div className="grid grid-cols-3 gap-[18px] mt-9 max-md:grid-cols-1" data-id="element-401">
          {testimonials.map((t, i) => <div key={i} className="bg-[rgba(201,151,43,.05)] border border-[rgba(201,151,43,.15)] rounded-lg p-[26px_24px] flex flex-col gap-4 transition-all duration-300 hover:border-[rgba(201,151,43,.3)] hover:-translate-y-[3px]" data-id="element-402">
              <div className="flex gap-[3px]" data-id="element-403">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-[13px] h-[13px] fill-dorado text-dorado" data-id="element-404" />)}
              </div>
              <p className="font-cormorant italic text-[1.05rem] text-crema leading-[1.7] flex-1" data-id="element-405">
                <span className="text-[2.5rem] text-dorado leading-[0] align-[-0.5rem] mr-1" data-id="element-406">
                  "
                </span>
                {t.quote}
              </p>
              <div className="flex items-center gap-3 mt-1" data-id="element-407">
                <div className="w-[42px] h-[42px] rounded-full bg-[linear-gradient(135deg,rgba(201,151,43,.3),rgba(201,151,43,.1))] border-2 border-[rgba(201,151,43,.25)] flex items-center justify-center text-dorado-claro font-bold text-[1rem] shrink-0" data-id="element-408">
                  {t.initial}
                </div>
                <div className="flex-1" data-id="element-409">
                  <div className="font-bold text-blanco text-[.9rem]" data-id="element-410">
                    {t.name}
                  </div>
                  <div className="text-[.78rem] text-gris-texto" data-id="element-411">{t.role}</div>
                </div>
              </div>
            </div>)}

          {screenshots.map((src, i) => <div key={`img-${i}`} className="bg-[rgba(201,151,43,.05)] border border-[rgba(201,151,43,.12)] rounded-lg overflow-hidden" data-id="element-412">
              <img src={src} alt={`Testimonio captura ${i + 1}`} className="w-full h-auto block object-cover" data-id="element-413" />
            </div>)}
        </div>
      </div>
    </section>;
}